function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M10.0334176,7.81920094 L15.0071098,12.7928932 L13.5928963,14.2071068 L8.62671792,9.24092843 L6.80000305,11.0871582 L6.80000305,6 L11.8333893,6 L10.0334176,7.81920094 Z M14.8000031,9 L12.8000031,9 L12.8000031,4 L2.80000305,4 L2.80000305,12 L9.80000305,12 L9.80000305,14 L1.80000305,14 C1.2477183,14 0.800003052,13.5522847 0.800003052,13 L0.800003052,3 C0.800003052,2.44771525 1.2477183,2 1.80000305,2 L13.8000031,2 C14.3522878,2 14.8000031,2.44771525 14.8000031,3 L14.8000031,9 Z",
  transform: "matrix(-1 0 0 1 15.807 -2)"
});
function SvgJump(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 13,
    viewBox: "0 0 16 13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJump);
export default __webpack_public_path__ + "static/media/jump.86fd58c76e21e8371d497414437d04f8.svg";
export { ForwardRef as ReactComponent };